import Alpine from "alpinejs";
import buyButton from "../alpine/buyButton";
import callToActionButtonTracker from "../alpine/callToActionButtonTracker";
import checkout from "../alpine/checkout";
import downloadDocumentTracker from "../alpine/downloadDocumentTracker";
import pdfProductSheet from "../alpine/pdfProductSheet";
import scrollSlider from "../alpine/scrollSlider";

declare global {
	interface Window {
		Alpine: typeof Alpine;
		dataLayer: DataLayerEvent[];
	}
}

interface DataLayerEvent {
	event: string;
	[key: string]: unknown;
}

window.Alpine = Alpine;

Alpine.data("scrollSlider", scrollSlider);
Alpine.data("buyButton", buyButton);
Alpine.data("checkout", checkout);
Alpine.data("pdfProductSheet", pdfProductSheet);
Alpine.data("downloadDocumentTracker", downloadDocumentTracker);
Alpine.data("callToActionButtonTracker", callToActionButtonTracker);
Alpine.start();
